// extracted by mini-css-extract-plugin
export default {"overlay":"Zx-z","bodyOpen":"_x-z","content":"ay-z","header":"by-z","close":"cy-z","closeNoHeading":"dy-z"};